import React, { useEffect } from 'react';
import { BrowserRouter as Router, Route, Routes, useLocation } from 'react-router-dom';
import Header from './components/Header/Header';
import Footer from './components/Footer/Footer';
import HomePage from './pages/HomePage/HomePage';
import PrivacyPage from './pages/PrivacyPage/PrivacyPage';
import CookiePolicyPage from './pages/CookiePolicyPage/CookiePolicyPage';
import TermsOfUsePage from './pages/TermsOfUsePage/TermsOfUsePage';
import AccessibilityPage from './pages/AccessibilityPage/AccessibilityPage';
import SupportPage from './pages/SupportPage/SupportPage';
import FraudAPIPage from './pages/FraudAPIPage/FraudAPIPage';
import AppointmentPage from './pages/AppointmentPage/AppointmentPage';

// Component to track page views in Google Tag Manager
function GTMPageViewTracker() {
  const location = useLocation();

  useEffect(() => {
    // Initialize dataLayer if it doesn't exist
    window.dataLayer = window.dataLayer || [];

    // Push page view event to GTM
    window.dataLayer.push({
      event: 'pageview',
      page: {
        path: location.pathname,
        search: location.search,
        hash: location.hash,
        url: window.location.href
      }
    });
  }, [location]);

  return null;
}

function App() {
  useEffect(() => {
    document.body.style.backgroundColor = '#0d1222';
  }, []);

  return (
    <Router>
      <GTMPageViewTracker />
      <Header />
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/privacy-policy" element={<PrivacyPage />} />
        <Route path="/cookie-policy" element={<CookiePolicyPage />} />
        <Route path="/terms-of-use" element={<TermsOfUsePage />} />
        <Route path="/accessibility" element={<AccessibilityPage />} />
        <Route path="/support" element={<SupportPage />} />
        <Route path="/fraud-api" element={<FraudAPIPage />} />
        <Route path="/appointment" element={<AppointmentPage />} />
      </Routes>
      <Footer />
    </Router>
  );
}

export default App;